import RiskLessonTaskModalUI from "./RiskLessonTaskModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import TextAreaInput from "../Inputs/TextAreaInput";
import { useFormik } from "formik";
import { riskValidationSchema } from "../../utils/validations";
import { createRisk, deleteRisk } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import CustomAvatar from "../ui/CustomAvatar";
import DeleteModel from "./DeleteModel";
import { useState } from "react";
import he from 'he';

function RiskTaskModal({ show, handleClose, task, fetchRisks, risks }) {
  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      task_ids: [task?.id],
    },
    validationSchema: riskValidationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      try {
        const response = await createRisk(values);
        if (response.status === 201) {
          showToast("Risk added successfully", "success");
          resetForm();
          fetchRisks();
        } else {
          showToast("Failed to add risk", "error");
        }
      } catch (error) {
        showToast("Error adding risk", "error");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [riskToDelete, setRiskToDelete] = useState(null);

  const confirmDelete = (id) => {
    setRiskToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmedDelete = async () => {
    if (riskToDelete) {
      await handleDeleteRisk(riskToDelete);
      setShowDeleteModal(false);
      setRiskToDelete(null);
    }
  };

  const handleDeleteRisk = async (id) => {
    try {
      const response = await deleteRisk(id);
      if (response.status === 200) {
        showToast("Risk deleted successfully", "success");
        fetchRisks();
      } else {
        showToast("Failed to delete risk", "error");
      }
    } catch (error) {
      showToast("Error deleting risk", "error");
    }
  };

  const renderRiskItem = (risk) => (
    <>
      <div className="d-flex align-items-top">
        <CustomAvatar user={risk.created_by} size="35px" fontSize={20} />
        <div className="ms-3">
          <h6>{risk.title}</h6>
          <p className="text-muted" style={{ fontSize: "14px" }}>
            {new Date(risk.created_at).toLocaleString()}
          </p>
          <p>{he.decode(risk.description.replace(/<[^>]+>/g, ""))}</p>
        </div>
      </div>
    </>
  );

  return (
    <>
      <RiskLessonTaskModalUI
        show={show}
        handleClose={handleClose}
        title="Risks"
        formFields={
          <>
            <ShortTextInput
              label="Title"
              id="title"
              name="title"
              required
              value={formik.values.title}
              onChange={formik.handleChange}
              placeholder="Enter risk title"
              error={formik.touched.title && formik.errors.title}
            />
            <TextAreaInput
              label="Description"
              id="description"
              name="description"
              required
              placeholder="Enter risk description"
              value={formik.values.description}
              onChange={formik.handleChange}
              error={formik.touched.description && formik.errors.description}
            />
          </>
        }
        onSubmit={formik.handleSubmit}
        submitting={formik.isSubmitting}
        submitLabel="Add Risk"
        list={risks}
        loading={false}
        onDelete={confirmDelete}
        renderItem={renderRiskItem}
        emptyMessage='No risks to display. Please add one.'
      />
      <DeleteModel
        open={showDeleteModal}
        closeAlert={() => setShowDeleteModal(false)}
        onClick={handleConfirmedDelete}
        type="risk"
      />
    </>
  );
}

export default RiskTaskModal;

